import { markWorkflowEnd } from '../utils/markWorkflowEnd';
import { routeMappings } from '../../constants';
import { Task } from '../interfaces';
import { TaskItemStatus } from '../constants';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useBasicDetails } from '../../store';

/**
 * If Workflow is completed (all tasks completed or hurdle is failed)
 * - Mark Workflow end
 * - Redirect to End Page or Hurdle Page
 */
export const useEndWorkflow = (tasks: Task[]): void => {
  const { currentWorkflowItem } = useBasicDetails();
  const history = useHistory();
  const location = useLocation();
  const isWorkflowCompleted = tasks.every((task: Task) => task.optional || task.status === TaskItemStatus.COMPLETED);
  const isAnyTaskHurdleFailed = tasks.some((task) => task.status === TaskItemStatus.HURDLE_FAILED);
  const onTaskListPage = location.pathname.includes(routeMappings[currentWorkflowItem.code]);

  useEffect(() => {
    const redirectToWorkflowEnd = async (): Promise<void> => {
      if (isAnyTaskHurdleFailed) {
        await markWorkflowEnd();
        history.push(routeMappings[`${currentWorkflowItem.code}_HURDLE_FAIL`]);
      } else if (isWorkflowCompleted) {
        await markWorkflowEnd();
        history.push(routeMappings[`${currentWorkflowItem.code}_END`]);
      }
    };
    const rrCheck = !sessionStorage.getItem('responseReuseInfo') || sessionStorage.getItem('responseReuseAcknowledged');
    if (onTaskListPage && rrCheck) {
      redirectToWorkflowEnd();
    }
  }, [isWorkflowCompleted, isAnyTaskHurdleFailed, history, onTaskListPage, currentWorkflowItem.code]);
};
